import * as actionTypes from '../utilities/ActionType';

const initialState = {
    sessionHeader:null,
    surveyList:[],
    isLoader:true,
    instrumentCss:[],
    itemList:[],
    answeredQuestionCount:0,
    scrollToQuestionId : 0,
    singleItemSliderValue:null,
    pointAssSliderValue:null,
    infiniteSliderValue:null,
    instrument:[],
    itemResponseStatus:[],
    isSpinner:true,
    connectionLost:true,
    getAllItemResponse:[],
    getAllItemResponseForMultiple:[],
    putAllResponse:null,
    assessmentInfoDataCollection:[],
    assessmentInfoDataCollectionData:[],
    isPutAllUpdate:true,
    putAllStatus:""
};

const surveyReducers = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.GET_SESSION_HEADER:
            return {
                ...state, sessionHeader:action.data
            };
        case actionTypes.GET_SURVEY:
            return {
                ...state, surveyList:action.data
            };
        case actionTypes.LOADER:
            return {
                ...state, isLoader:action.data
            }
        case actionTypes.GET_CSS:
            return {
                ...state, instrumentCss:action.data
            };
        case actionTypes.GET_ITEMS:
            return {
                ...state, itemList:action.data
            };
        case actionTypes.GET_ANSWERED_QUESTION:
            return {
                ...state, answeredQuestionCount:action.data
            };
        case actionTypes.SCROLL_TO_QUESTION:
            return {
                ...state, scrollToQuestionId:action.data
            };
        case actionTypes.SINGLE_ITEM_RESET_SLIDER:
            return {
                ...state, singleItemSliderValue:action.data
            };
        case actionTypes.POINT_ASSIGNMENT_RESET_SLIDER:
            return {
                ...state, pointAssSliderValue:action.data
            };
        case actionTypes.INFINITE_RESET_SLIDER:
            return {
                ...state, infiniteSliderValue:action.data
            };
        case actionTypes.LOAD_INSTRUMENT:
            return {
                ...state, instrument:action.data
            };
        case actionTypes.PUT_ALL_SUCCESS:
            return {
                ...state, itemResponseStatus:action.data
            };
        case actionTypes.PUT_ALL_SUCCESS_STATUS:
            return {
                ...state, putAllStatus:action.data
            }
        case actionTypes.PUT_ALL_ERROR:
            return {
                ...state, itemResponseStatus:action.data
            };
        case actionTypes.RESET_ALL_SURVEY:
            return {
                ...state, surveyList:[], itemList:[]
            };
        case actionTypes.SPINNER:
            return {
                ...state, isSpinner:action.data
            }
        case actionTypes.LOST_CONNECTION:
            return {
                ...state, connectionLost:action.data
            }
        case actionTypes.GET_ALL_ITEM_RESPONSE:
            return {
                ...state, getAllItemResponse:action.data
            }
        case actionTypes.GET_ALL_FOR_MULTIPLE_RESPONSE:
            return {
                ...state, getAllItemResponseForMultiple:action.data
            }
        case actionTypes.PUT_ALL_RESPONSE:
            return {
                ...state, putAllResponse:action.data
            }
        case actionTypes.GET_ASSESSMENT_INFO:
            return {
                ...state, assessmentInfoDataCollection:action.data
            }
        case actionTypes.GET_ASSESSMENT_INFO_COL:
            return {
                ...state, assessmentInfoDataCollectionData:action.data
            }
        case actionTypes.IS_API_UPDATE:
                return {
                    ...state, isPutAllUpdate:action.data
                }
        default:
            return state;
    }
};

export default surveyReducers;
